/* eslint-disable no-console */
import { setLogger } from "react-query";

const noop = (): void => {};
export const silenceLogger = (): void => {
  setLogger({
    log: noop,
    warn: noop,
    error: noop,
  });
};

export const restoreLogger = (): void => {
  setLogger({
    log: (message) => {
      // eslint-disable-next-line no-console
      console.log(message);
    },
    warn: (message) => {
      // eslint-disable-next-line no-console
      console.warn(message);
    },
    error: (error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    },
  });
};
